import {IpType} from './iptype.model';
import {Actions} from './actions.model';
import {Destinations} from './destinations.model';

export class Command {
  constructor(public device: string,
              public target_type: IpType,
              public target: string,
              public destinationType: Destinations,
              public command?: Actions) {
  }

}
